import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { FormHelperText, Icon } from "@mui/material";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { useNotification } from "context/notification.context";
import { addTrackingMessage, updateTrackingMessage } from "network/service";

export default function AddTrackingMessage(props) {
  const [newField, setNewField] = useState({ name: "", content: "", is_active: true });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const { showNotification } = useNotification();

  const validate = () => {
    let isValid = true;
    const newErrors = {};

    if (newField.name.trim() === "") {
      newErrors.name = "Name is required";
      isValid = false;
    }
    if (newField.content.trim() === "") {
      newErrors.content = "Message content is required";
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };

  const submit = async () => {
    try {
      if (!validate()) return;
      setLoading(true);

      const payload = {
        name: newField.name.trim(),
        content: newField.content.trim(),
        is_active: !!newField.is_active,
      };

      if (props.details && props.details._id) {
        await updateTrackingMessage(props.details._id, payload);
        showNotification("success", "Success", "Updated tracking message successfully");
      } else {
        await addTrackingMessage(payload);
        showNotification("success", "Success", "Added tracking message successfully");
      }

      props.handlesuccess();
      props.handleclose();
    } catch (err) {
      console.log(err);
      showNotification("error", "Error", "Failed to save tracking message.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (props.details) {
      setNewField({
        name: props.details.name || "",
        content: props.details.content || "",
        is_active: props.details.is_active !== false,
      });
      return;
    }
    setNewField({ name: "", content: "", is_active: true });
  }, [props.details]);

  return (
    <Dialog
      id="modal-display"
      open={props.isopen}
      aria-labelledby="form-dialog-title"
      aria-describedby="modal-modal-description"
      maxWidth="90%"
      maxHeight="90%"
      onClose={props.handleclose}
      disableBackdropClick
    >
      <div>
        <DialogTitle>{props.details ? "Edit Tracking Message" : "Add Tracking Message"}</DialogTitle>
      </div>
      <DialogContent sx={{ minWidth: 500 }}>
        <Grid container direction="column" spacing={2}>
          <Grid item>
            <MDInput
              label="Name"
              value={newField.name}
              fullWidth
              onChange={(e) => {
                setNewField({ ...newField, name: e.target.value });
              }}
              helperText={
                <FormHelperText sx={{ color: "red", fontWeight: 800, margin: 0 }}>
                  {errors.name}
                </FormHelperText>
              }
            />
          </Grid>
          <Grid item>
            <MDInput
              label="Message Content"
              multiline
              rows={4}
              value={newField.content}
              fullWidth
              onChange={(e) => {
                setNewField({ ...newField, content: e.target.value });
              }}
              helperText={
                <FormHelperText sx={{ color: "red", fontWeight: 800, margin: 0 }}>
                  {errors.content}
                </FormHelperText>
              }
            />
          </Grid>
          <Grid item>
            <FormControlLabel
              control={
                <Switch
                  checked={!!newField.is_active}
                  onChange={(e) => {
                    setNewField({ ...newField, is_active: e.target.checked });
                  }}
                  color="info"
                />
              }
              label={newField.is_active ? "Active" : "Inactive"}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <MDButton variant="gradient" color="error" onClick={props.handleclose}>
          <Icon>close</Icon>&nbsp;Cancel
        </MDButton>
        <MDButton variant="gradient" color="success" onClick={submit} disabled={loading}>
          <Icon>save</Icon>&nbsp;Save
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}
